<template>
  <form
    id="registration-form"
    @submit.prevent="saveRegistration(registration)"
  >
    <p>
      ITC Compliance Ltd, who regulate us for some financial service activity created a unique
      online customer portal to provide you with and store your important compliance information
      and documentation.

      Please fill out the information below to allow us to verify it is really you
    </p>

    <div
      v-if="generalErrors && generalErrors.length > 0"
      class="alert alert-danger"
      role="alert"
    >
      <ul class="help-block list-unstyled">
        <li
          v-for="(error, key) in generalErrors"
          :key="key"
          v-text="error"
        />
      </ul>
    </div>

    <div class="row">
      <h3 class="col-md-12">
        Your Information
      </h3>
    </div>
    <div class="row">
      <component
        :is="editing ? `${field.type}-field` : 'span-field'"
        v-for="(field, key) in fields(['last_name', 'company_name'])"
        :key="`field${key}`"
        v-model="registration[key]"
        :name="key"
        :validation="field.validation"
        v-bind="field"
        :data-vv-scope="'registration'"
      />
    </div>

    <div class="row">
      <component
        :is="editing ? `${field.type}-field` : 'span-field'"
        v-for="(field, key) in fields(['postcode'])"
        :key="`field${key}`"
        v-model="registration[key]"
        :name="key"
        :validation="field.validation"
        v-bind="field"
        :data-vv-scope="'registration'"
      />
    </div>

    <div class="row">
      <component
        :is="editing ? `${field.type}-field` : 'span-field'"
        v-for="(field, key) in fields(['email', 'telephone'])"
        :key="`field${key}`"
        v-model="registration[key]"
        :name="key"
        :validation="field.validation"
        v-bind="field"
        :data-vv-scope="'registration'"
      />
    </div>

    <div class="row">
      <h3 class="col-md-12">
        Security
      </h3>
    </div>

    <div class="row">
      <div class="col-md-12">
        <p>
          Please pick a security question and answer to help you recover the account if you forget
          your password
        </p>
      </div>

      <component
        :is="editing ? `${field.type}-field` : 'span-field'"
        v-for="(field, key) in fields(['security_question', 'security_answer'])"
        :key="`field${key}`"
        v-model="registration[key]"
        :name="key"
        :validation="field.validation"
        v-bind="field"
        :data-vv-scope="'registration'"
      />
    </div>

    <div class="row">
      <div class="col-md-12">
        <p>
          Pick a secure password to make sure all your information stays safe
        </p>
      </div>

      <component
        :is="editing ? `${field.type}-field` : 'span-field'"
        v-for="(field, key) in fields(['password', 'password_confirm'])"
        :key="`field${key}`"
        v-model="registration[key]"
        :name="key"
        :validation="field.validation"
        v-bind="field"
        :data-vv-scope="'registration'"
      />
    </div>

    <input
      v-if="editing"
      type="submit"
      class="btn btn-primary pull-right"
      value="Submit"
    >
  </form>
</template>

<script>
import _ from 'lodash';
import RegistrationModel from '../../../models/registration';
import DateField from '../../partials/field/date.vue';
import SelectField from '../../partials/field/select.vue';
import SpanField from '../../partials/field/span.vue';
import TextField from '../../partials/field/text.vue';
import TelephoneField from '../../partials/field/telephone.vue';
import PasswordField from '../../partials/field/password.vue';
import recaptchaMixin from '../../../mixins/recaptcha';

export default {
  components: {
    DateField,
    SelectField,
    SpanField,
    TelephoneField,
    TextField,
    PasswordField,
  },
  mixins: [recaptchaMixin],
  props: {
    groupSlug: {
      type: String,
      default: 'default',
    },
    editing: {
      type: Boolean,
      default: true,
    },
    formConfigurationJson: {
      type: String,
      default: '{}',
    },
    token: {
      type: String,
      default: null,
    },
  },
  data() {
    const formConfiguration = JSON.parse(this.formConfigurationJson);

    const registrationModel = new RegistrationModel({}, formConfiguration, this.token);
    registrationModel.setDealerSlug(this.groupSlug);

    return {
      formConfiguration,
      registration: registrationModel,
      generalErrors: [],
    };
  },
  methods: {
    saveRegistration(registration) {
      this.$validator.errors.clear();
      const app = this;
      app.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            window.grecaptcha.enterprise.execute(this.siteKey, { action: 'register' })
              .then((token) => {
                registration.setRecaptchaToken(token);
                registration.save()
                  .then(() => {
                    window.location.href = `/${this.groupSlug}/login`;
                  }).catch((errors) => {
                    this.generalErrors = errors.general;
                    _.each(errors, (errs, key) => {
                      this.$validator.errors.add(`form-field-${key}`, errs[0]);
                    });
                  });
              });
          }
        });
    },

    fields(pick) {
      return _.pick(this.registration.fields, pick);
    },
  },
};
</script>
